import { Route } from 'src/routes/Route'

export const MyGiftsRoute = Route({ path: '/my-gifts' })
export type MyGiftsRoute = Route<typeof MyGiftsRoute>
